import script from "./TransactionSuccessContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionSuccessContent.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionSuccessContent.vue?vue&type=style&index=0&id=4b24e9f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b24e9f8"]])

export default __exports__